import React, { useContext } from 'react';
import cx from 'classnames';

import styles from './Theme.module.scss';

export interface Props {
  children?: React.ReactNode;
  theme?: 'light' | 'dark';
  className?: Parameters<typeof cx>[0];
}

export const ThemeContext = React.createContext<Props['theme']>('light');

export const Theme: React.FC<Props> = ({
  children,
  className,
  theme = 'light',
}) => (
  <ThemeContext.Provider value={theme}>
    <div data-theme={theme} className={cx(className, [styles[theme]])}>
      {children}
    </div>
  </ThemeContext.Provider>
);

export const useThemeContext = () => useContext(ThemeContext);

Theme.displayName = 'Theme';
export default Theme;
export { styles };
